import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";
import TimeFieldUtils from "@/utils/common/TimeFieldUtils.ts";

export default class TimeValueFormatter extends AbsEditViewValueFormatter {
  private static _instance: TimeValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new TimeValueFormatter();
    return this._instance;
  }

  override format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any): any {
    return TimeFieldUtils.formatTime(specs, value);
  }

  override parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any): string {
    return TimeFieldUtils.timeToString(specs, value);
  }
}
